import { ORGANIZATION_SELECTION_STATUS } from '../../constants/organization-selection.constants';
import { DEVICE_FLAGS } from '../../constants/deviceFlags';
import { getUserId } from './user.selector';

export const isSwitchOrganizationAvailable = ({ availableOrganizations }) => {
  return (
    availableOrganizations.organizations.length >= 1 ||
    availableOrganizations.organizations.some(org => !org.activated)
  );
};

// Unactivated accounts go through ADD_ACCOUNT — switching into one would fail.
export const filterSelectableOrganizations = (organizations = []) =>
  organizations.filter(org => org.activated);

export const getSelectableOrganizations = ({ availableOrganizations }) =>
  filterSelectableOrganizations(availableOrganizations?.organizations || []);

export const getOrganizationSelectionStatus = ({ availableOrganizations }) =>
  availableOrganizations?.selectionStatus || ORGANIZATION_SELECTION_STATUS.IDLE;

export const isOrganizationSelectionPending = state =>
  getOrganizationSelectionStatus(state) === ORGANIZATION_SELECTION_STATUS.PENDING;

// True while the gate owns the screen (showing or still deciding).
export const isOrganizationSelectionBlocking = state => {
  const status = getOrganizationSelectionStatus(state);
  return (
    status === ORGANIZATION_SELECTION_STATUS.RESOLVING ||
    status === ORGANIZATION_SELECTION_STATUS.PENDING
  );
};

/** The org the user last switched into — see `rememberSwitchedOrganization`. */
export const getRememberedOrganizationId = state => {
  const userId = getUserId(state);
  if (!userId) return null;
  return state.deviceFlags?.[DEVICE_FLAGS.SELECTED_ORGANIZATION_BY_USER]?.[userId] || null;
};

// Last used, then active — but only if still selectable: the remembered id is
// persisted device state and access may have been revoked since.
export const getInitialSelectedOrganizationId = state => {
  const selectable = getSelectableOrganizations(state);
  const candidates = [getRememberedOrganizationId(state), state.organization?.id];
  const match = candidates.find(id => id && selectable.some(org => org.id === id));
  return match || selectable[0]?.id || null;
};
